<template>
  <div>
    <div class="loan-details-container pt-5">
      <p class="dashboard__back" @click="$router.back()">Back</p>

      <div class="loan-details-container__header">
        <div class="header">
          <h4>Member information</h4>
        </div>
      </div>

      <div class="loan-details-container__body">
        <div class="details">
          <h4>
            {{ loanDetails && loanDetails.loan && loanDetails.loan.user }}
          </h4>

          <div class="info-container">
            <div>
              <p class="key">Amount:</p>
              <p>
                <b>
                  ₦
                  {{
                    loanDetails &&
                      loanDetails.loan &&
                      loanDetails.loan.requestedAmount &&
                      new Intl.NumberFormat().format(
                        Number(loanDetails.loan.requestedAmount)
                      )
                  }}</b
                >
              </p>
            </div>

            <div>
              <p class="key">Tenure:</p>
              <p>
                <b>{{
                  loanDetails &&
                    loanDetails.loan &&
                    loanDetails.loan.tenure &&
                    loanDetails.loan.tenure
                }}</b>
              </p>
            </div>

            <div>
              <p class="key">Debit Mandate:</p>
              <p><b>-</b></p>
            </div>

            <div>
              <p class="key">Maximum approvable amount:</p>
              <p>
                <b>{{
                  this.loanDetails && this.loanDetails.maximumApprovableAmount
                    ? this.loanDetails.maximumApprovableAmount
                    : "-"
                }}</b>
              </p>
            </div>
            <div>
              <p class="key">Status:</p>
              <StatusBadge :status="loanDetails && loanDetails.loan.status" />
            </div>
            <div class="header-grp">
              <div v-if="loanStatusCheck" class="btn-grp">
                <button
                  type="button"
                  class="initiate-btn"
                  @click="handleRepaymentModal"
                >
                  <svgicon
                    v-if="repaymentLoader"
                    icon="spinner"
                    class="button__loader"
                  ></svgicon
                  >Initiate repayment
                </button>
                <button
                  type="button"
                  class="mark-btn"
                  @click="handleMarkAsPaid"
                >
                  <svgicon
                    v-if="markAsPaid"
                    icon="spinner"
                    class="button__loader"
                  ></svgicon
                  >Mark as paid
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="cta">
          <button
            v-if="
              loanDetails &&
                loanDetails.loan &&
                loanDetails.loan.status &&
                loanDetails.loan.status &&
                (loanDetails.loan.status === 'pending' ||
                  loanDetails.loan.status === 'processing')
            "
            class="approve-btn"
            @click="onApprovalTrigger"
          >
            Approve
          </button>

          <button
            v-if="
              loanDetails &&
                loanDetails.loan &&
                loanDetails.loan.status &&
                loanDetails.loan.status &&
                loanDetails.loan.status === 'approved'
            "
            class="approve-btn"
            @click="onDisbursementTrigger"
          >
            Disburse
          </button>
          <button
            v-if="
              loanDetails &&
                loanDetails.loan &&
                loanDetails.loan.status &&
                loanDetails.loan.status &&
                (loanDetails.loan.status === 'pending' ||
                  loanDetails.loan.status === 'processing')
            "
            class="cancel-btn"
            @click="showRejectionModal = true"
          >
            Decline
          </button>
        </div>
      </div>

      <!-- financial information -->

      <div class="loan-details-container__financial-header">
        <div class="financial-info-header-container">
          <select
            v-model="financialInformationOption"
            name=""
            id=""
            class="form__select dashboard__filter"
          >
            <option :value="null" disabled selected>Select an option</option>
            <option value="financial_info">Financial Information</option>
            <option value="repayment_info">Repayment Information</option>
          </select>
        </div>
      </div>
      <div class="loan-details-card">
        <h4>
          {{
            financialInformationOption === "financial_info"
              ? "FINANCIAL INFORMATION"
              : "REPAYMENT INFORMATION"
          }}
        </h4>

        <div
          v-if="financialInformationOption === 'financial_info'"
          class="loan-details-container__financial-body"
        >
          <div>
            <div class="info-container">
              <div class="financial-info-tab">
                <div
                  class="header-item"
                  :class="{
                    'active-header': activeFinancialInfoTab === 'income'
                  }"
                  @click="activeFinancialInfoTab = 'income'"
                >
                  Income
                </div>
                <div
                  class="header-item"
                  :class="{
                    'active-header': activeFinancialInfoTab === 'spend'
                  }"
                  @click="activeFinancialInfoTab = 'spend'"
                >
                  Spend
                </div>
                <div
                  class="header-item"
                  :class="{
                    'active-header': activeFinancialInfoTab === 'pattern'
                  }"
                  @click="activeFinancialInfoTab = 'pattern'"
                >
                  Pattern
                </div>
                <div
                  class="header-item"
                  :class="{
                    'active-header': activeFinancialInfoTab === 'behavioural'
                  }"
                  @click="activeFinancialInfoTab = 'behavioural'"
                >
                  Behavioural
                </div>
                <div
                  class="header-item"
                  :class="{
                    'active-header': activeFinancialInfoTab === 'cash'
                  }"
                  @click="activeFinancialInfoTab = 'cash'"
                >
                  Cash flow
                </div>
                <div
                  class="header-item"
                  :class="{
                    'active-header': activeFinancialInfoTab === 'credit'
                  }"
                  @click="activeFinancialInfoTab = 'credit'"
                >
                  Credit Score
                </div>
              </div>
            </div>

            <!-- Income details section -->
            <div
              v-if="activeFinancialInfoTab === 'income'"
              class="info-container"
            >
              <div>
                <p>Average predicted salary</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.incomeDetails &&
                        this.loanDetails.incomeDetails.averagePredictedSalary &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.incomeDetails
                              .averagePredictedSalary
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Lowest salary</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.incomeDetails &&
                        this.loanDetails.incomeDetails.lowestSalary &&
                        new Intl.NumberFormat().format(
                          Number(this.loanDetails.incomeDetails.lowestSalary)
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Most recent salary</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.incomeDetails &&
                        this.loanDetails.incomeDetails.mostRecentSalary &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.incomeDetails.mostRecentSalary
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>No of salary payments</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.incomeDetails &&
                        this.loanDetails.incomeDetails
                          .numberOfSalaryPayments) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Expected salary day</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.incomeDetails &&
                        this.loanDetails.incomeDetails
                          .expectedSalaryPaymentDay &&
                        formatDate(
                          this.loanDetails.incomeDetails
                            .expectedSalaryPaymentDay
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>
            </div>
            <!-- Income details section -->

            <!-- Spend details section -->
            <div
              v-if="activeFinancialInfoTab === 'spend'"
              class="info-container"
            >
              <div>
                <p>Most frequent spend category</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails
                          .mostFrequentSpendCategory) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Most frequent spend expenses</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails.mostFrequentExpense) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Most frequent expense amount</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails
                          .mostFrequentExpenseAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.spendingDetails
                              .mostFrequentExpenseAmount
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Highest spend</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails.highestSpend &&
                        new Intl.NumberFormat().format(
                          Number(this.loanDetails.spendingDetails.highestSpend)
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Date of highest spend</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails
                          .monthWithHighestSpend) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Average monthly expenses</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails
                          .averageMonthlyTotalExpenses &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.spendingDetails
                              .averageMonthlyTotalExpenses
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Average recurring expense</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails
                          .averageMonthlyRecurringExpense &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.spendingDetails
                              .averageMonthlyRecurringExpense
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Total expense</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.spendingDetails &&
                        this.loanDetails.spendingDetails.totalExpenses &&
                        new Intl.NumberFormat().format(
                          Number(this.loanDetails.spendingDetails.totalExpenses)
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>
            </div>
            <!-- Spend details section -->

            <!-- Pattern details section -->
            <div
              v-if="activeFinancialInfoTab === 'pattern'"
              class="info-container"
            >
              <div>
                <p>Total transactions</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .totalNumberOfTransactions) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer outflows</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .noOfSelfTransferOutflows) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer outflow amount</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .selfTransferOutflowAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.transactionPattern
                              .selfTransferOutflowAmount
                          )
                        )) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer inflows</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .noOfSelfTransferInflows) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer inflow amount</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .selfTransferInflowAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.transactionPattern
                              .selfTransferInflowAmount
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Debit transactions percentage</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .percentDebitTransactions + "%") ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Credit transactions percentages</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .percentCreditTransactions + "%") ||
                        "-"
                    }}</b
                  >
                </p>
              </div>
            </div>
            <!-- Pattern details section -->

            <!-- Behavioural details section -->
            <div
              v-if="activeFinancialInfoTab === 'behavioural'"
              class="info-container"
            >
              <div>
                <p>Account activity</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails.accountActivity &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.behaviorDetails.accountActivity
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Account sweep</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails.accountSweep) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Gambling rate</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails.gamblingRate !==
                          null &&
                        this.loanDetails.behaviorDetails.gamblingRate + "%") ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Betting transactions</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails
                          .numberOfBettingTransactions &&
                        this.loanDetails.behaviorDetails
                          .numberOfBettingTransactions) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Prior loan owed</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails.totalLoanAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.behaviorDetails.totalLoanAmount
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Loan repayment amount</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails
                          .totalLoanRepaymentAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.behaviorDetails
                              .totalLoanRepaymentAmount
                          )
                        )) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Number of loan transactions</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.behaviorDetails &&
                        this.loanDetails.behaviorDetails
                          .numberLoanTransactions) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Date of last loan payment</p>
                <p>
                  <b>-</b>
                </p>
              </div>
            </div>
            <!-- Behavioural details section -->

            <!-- Cash flows details section -->
            <div
              v-if="activeFinancialInfoTab === 'cash'"
              class="info-container"
            >
              <div>
                <p>Total transactions</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .totalNumberOfTransactions) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer outflows</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .noOfSelfTransferOutflows) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer outflow amount</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .selfTransferOutflowAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.transactionPattern
                              .selfTransferOutflowAmount
                          )
                        )) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer inflows</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .noOfSelfTransferInflows) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Self transfer inflow amount</p>
                <p>
                  <b
                    >₦
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .selfTransferInflowAmount &&
                        new Intl.NumberFormat().format(
                          Number(
                            this.loanDetails.transactionPattern
                              .selfTransferInflowAmount
                          )
                        )) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Debit transactions percentage</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .percentDebitTransactions) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Credit transactions percentages</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.transactionPattern &&
                        this.loanDetails.transactionPattern
                          .percentCreditTransactions) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>
            </div>
            <!-- Cash flows details section -->

            <!-- Credit score details section -->
            <div
              v-if="activeFinancialInfoTab === 'credit'"
              class="info-container"
            >
              <div>
                <p>Base Score</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.creditScore &&
                        this.loanDetails.creditScore.baseScore) ||
                        "-"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Calculated Score</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.creditScore &&
                        this.loanDetails.creditScore.calculatedScore) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>

              <div>
                <p>Rules Score</p>
                <p>
                  <b>
                    {{
                      (this.loanDetails &&
                        this.loanDetails.creditScore &&
                        this.loanDetails.creditScore.rulesScore) ||
                        "0"
                    }}</b
                  >
                </p>
              </div>
            </div>
            <!-- Credit score details section -->
          </div>

          <div class="chart-container">
            <!-- chart section -->
            <div></div>
          </div>
        </div>

        <!-- reapyment table -->
        <div
          style="padding-top: 20px "
          v-if="financialInformationOption === 'repayment_info'"
        >
          <div class="list-of-loans-table-container">
            <table class="list-of-loans-table">
              <thead>
                <tr>
                  <th class="list-of-loans-table-heading">
                    #
                  </th>
                  <th class="list-of-loans-table-heading">
                    DATE DUE
                  </th>
                  <th class="list-of-loans-table-heading">
                    DATE PAID
                  </th>
                  <th class="list-of-loans-table-heading">
                    PRINCIPAL
                  </th>

                  <th class="list-of-loans-table-heading">
                    BALANCE OF LOAN
                  </th>
                  <th class="list-of-loans-table-heading">
                    INTEREST
                  </th>
                  <th class="list-of-loans-table-heading">
                    OVERDUE INTEREST
                  </th>
                  <th class="list-of-loans-table-heading">
                    FEES
                  </th>
                  <th class="list-of-loans-table-heading">
                    AMOUNT DUE
                  </th>
                  <th class="list-of-loans-table-heading">
                    AMOUNT PAID
                  </th>
                  <th class="list-of-loans-table-heading">
                    OUTSTANDING
                  </th>
                  <th class="list-of-loans-table-heading">
                    STATUS
                  </th>
                  <th class="list-of-loans-table-heading">
                    ACTION
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(repayment, index) in repaymentList" :key="index">
                  <td class="list-of-loans-table-data">
                    {{ index + 1 }}
                  </td>
                  <td class="list-of-loans-table-data">
                    {{ repayment && repayment.dueDate | formatDate }}
                  </td>
                  <td class="list-of-loans-table-data">
                    {{ repayment && repayment.datePaid | formatDate }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.principal)
                        )
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.loanBalance)
                        )
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.interest)
                        )
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.overdueInterest)
                        )
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(Number(repayment.fees))
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.amountDue)
                        )
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.amountPaid)
                        )
                    }}
                  </td>
                  <td class="list-of-loans-table-data">
                    ₦{{
                      repayment &&
                        new Intl.NumberFormat().format(
                          Number(repayment.outstanding)
                        )
                    }}
                  </td>
                  <td
                    class="list-of-loans-table-data"
                    style="text-transform: capitalize"
                  >
                    {{ repayment && repayment.status }}
                  </td>
                  <td
                    @click="onRepaymentTrigger(repayment)"
                    class="list-of-loans-table-data-action"
                  >
                    Mark as paid
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- reapyment table -->
      </div>
      <!-- additional information -->
      <div class="additional-info-container__header">
        <div class="dashboard__tab dashboard__profile-tab">
          <b-tabs>
            <b-tab title="Personal Information" active>
              <div class="additional-info-container__body">
                <div class="header-container">
                  <!-- dropdown to select info to view -->
                  <div>
                    <select
                      v-model="personalInformationOption"
                      name=""
                      id=""
                      class="form__select dashboard__filter"
                    >
                      <option :value="null" disabled selected
                        >Select an option</option
                      >
                      <option value="basic_information"
                        >Basic Information</option
                      >
                      <option value="employment_information"
                        >Employment Information</option
                      >
                      <option value="next_of_kin">Next Of Kin</option>
                      <option value="document_uploads">Document Uploads</option>
                      <option value="bank_details">Bank Details</option>
                    </select>
                  </div>

                  <!-- dropdown to select info to view -->

                  <button
                    type="button"
                    class="createAcct__ctaBtn analyse-btn"
                    @click="handleBankStatementAnalysis"
                  >
                    <svgicon
                      v-if="analysingLoader"
                      icon="spinner"
                      class="button__loader"
                    ></svgicon
                    >Reanalyze bank statement
                  </button>
                </div>

                <hr style="margin-bottom: 30px" />

                <!-- checks for each view -->

                <!-- basic information -->
                <div v-if="personalInformationOption === 'basic_information'">
                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Marital Status</p>
                      <div class="input-box info-details">
                        {{ this.userDetails && this.userDetails.maritalStatus }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Home Address</p>
                      <div class="input-box info-details" style="">
                        {{ this.userDetails && this.userDetails.address }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Email Address</p>
                      <div class="input-box info-details">
                        {{ this.userDetails && this.userDetails.email }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Date of Birth</p>
                      <div class="input-box info-details">
                        {{ this.userDetails && this.userDetails.dob }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>BVN</p>
                      <div class="input-box info-details">
                        {{ this.userDetails && this.userDetails.bvn }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Phone Number</p>
                      <div class="input-box info-details">
                        {{ this.userDetails && this.userDetails.phone }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- employment information -->
                <div
                  v-if="personalInformationOption === 'employment_information'"
                >
                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el" style="margin-bottom: 18px;">
                      <p>Employment Status</p>
                      <div class="input-box info-details">
                        {{
                          this.employmentDetails &&
                            this.employmentDetails.employmentStatus
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Name of company</p>
                      <div class="input-box info-details">
                        {{
                          this.employmentDetails &&
                            this.employmentDetails.companyName
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Role in company</p>
                      <div class="input-box info-details">
                        {{
                          this.employmentDetails &&
                            this.employmentDetails.jobTitle
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Company Address</p>
                      <div class="input-box info-details">
                        {{
                          this.employmentDetails &&
                            this.employmentDetails.companyAddress
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Date you joined</p>
                      <div class="input-box info-details">
                        {{
                          this.employmentDetails &&
                            this.employmentDetails.employmentDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Next of kin information -->
                <div v-if="personalInformationOption === 'next_of_kin'">
                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>First Name</p>
                      <div class="input-box info-details">
                        {{
                          this.nextOfKinDetails &&
                            this.nextOfKinDetails.firstName
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Last Name</p>
                      <div class="input-box info-details">
                        {{
                          this.nextOfKinDetails &&
                            this.nextOfKinDetails.lastName
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Next of kin's email</p>
                      <div class="input-box info-details">
                        {{
                          this.nextOfKinDetails && this.nextOfKinDetails.email
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>phone number</p>
                      <div class="input-box info-details">
                        {{
                          this.nextOfKinDetails && this.nextOfKinDetails.phone
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Home address</p>
                      <div class="input-box info-details">
                        {{
                          this.nextOfKinDetails && this.nextOfKinDetails.address
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>relationship</p>
                      <div class="input-box info-details">
                        {{
                          this.nextOfKinDetails &&
                            this.nextOfKinDetails.relationship
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Document uploads information -->
                <div v-if="personalInformationOption === 'document_uploads'">
                  <div class="dashboard__form-group">
                    <div
                      v-if="
                        this.uploadedDocuments &&
                          this.uploadedDocuments.identificationFrontPhotoUrl
                      "
                    >
                      <h5 style="text-transform: uppercase">
                        {{
                          (this.uploadedDocuments &&
                            this.uploadedDocuments.identificationType) ||
                            "Document"
                        }}
                      </h5>
                      <div
                        v-if="
                          this.uploadedDocuments &&
                            this.uploadedDocuments.identificationFrontPhotoUrl
                        "
                        class="document-upload-icon-container"
                      >
                        <svgicon
                          icon="document-upload"
                          class="document-upload-icon"
                        ></svgicon>
                        <p
                          @click="
                            handleDocumentDownload(
                              'identificationFrontPhotoUrl'
                            )
                          "
                        >
                          {{
                            this.uploadedDocuments &&
                              this.uploadedDocuments
                                .identificationFrontPhotoUrl &&
                              onTruncateText(
                                this.uploadedDocuments
                                  .identificationFrontPhotoUrl
                              )
                          }}
                        </p>
                      </div>

                      <div
                        v-if="
                          this.uploadedDocuments &&
                            this.uploadedDocuments.identificationBackPhotoUrl
                        "
                        class="document-upload-icon-container"
                      >
                        <svgicon
                          icon="document-upload"
                          class="document-upload-icon"
                        ></svgicon>
                        <p
                          @click="
                            handleDocumentDownload('identificationBackPhotoUrl')
                          "
                        >
                          {{
                            this.uploadedDocuments &&
                              this.uploadedDocuments
                                .identificationBackPhotoUrl &&
                              onTruncateText(
                                this.uploadedDocuments
                                  .identificationBackPhotoUrl
                              )
                          }}
                        </p>
                      </div>
                    </div>

                    <div
                      v-if="
                        this.uploadedDocuments &&
                          this.uploadedDocuments.utilityBillUrl
                      "
                    >
                      <h5 style="text-transform: uppercase">Utility Bill</h5>
                      <div class="document-upload-icon-container">
                        <svgicon
                          icon="document-upload"
                          class="document-upload-icon"
                        ></svgicon>
                        <p @click="handleDocumentDownload('utilityBillUrl')">
                          {{
                            this.uploadedDocuments &&
                              this.uploadedDocuments.utilityBillUrl &&
                              onTruncateText(
                                this.uploadedDocuments.utilityBillUrl
                              )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group">
                    <div>
                      <h5 style="text-transform: uppercase">
                        PDF bank statement
                      </h5>
                      <div
                        v-if="
                          this.bankStatement &&
                            this.bankStatement.bankStatementUrl
                        "
                        class="document-upload-icon-container"
                      >
                        <svgicon
                          icon="document-upload"
                          class="document-upload-icon"
                        ></svgicon>
                        <p
                          @click="
                            handleDocumentDownload('bankStatementUrl', true)
                          "
                        >
                          {{
                            this.bankStatement &&
                              this.bankStatement.bankStatementUrl &&
                              onTruncateText(
                                this.bankStatement.bankStatementUrl
                              )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Bank details information -->
                <div v-if="personalInformationOption === 'bank_details'">
                  <div class="dashboard__form-group">
                    <div
                      class="bank-card-container"
                      v-for="(bankDetails, index) in bankDetails"
                      :key="index"
                    >
                      <svgicon
                        icon="design-element-three"
                        class="card-details-icon"
                      ></svgicon>
                      <div class="fields">
                        <h3>{{ bankDetails && bankDetails.accountName }}</h3>

                        <div class="details-container">
                          <p>{{ bankDetails && bankDetails.bank }}</p>

                          <p>{{ bankDetails && bankDetails.accountNumber }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- checks for each view -->
              </div>
            </b-tab>
            <b-tab title="Additional Information">
              <div class="additional-info-container__body">
                <!-- dropdown to select additional info to view -->
                <div>
                  <select
                    v-model="additionalInformationOption"
                    name=""
                    id=""
                    class="form__select dashboard__filter"
                  >
                    <option :value="null" disabled selected
                      >Select an option</option
                    >
                    <option value="guarantor_information">Guarantors</option>
                  </select>
                </div>

                <!-- dropdown to select additional info to view -->

                <hr style="margin-bottom: 30px" />

                <!-- Guarantors information -->
                <div
                  v-if="additionalInformationOption === 'guarantor_information'"
                >
                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Full Name</p>
                      <div class="input-box info-details">
                        {{
                          this.guarantorDetails &&
                            this.guarantorDetails.firstName &&
                            this.guarantorDetails.lastName &&
                            this.guarantorDetails.firstName +
                              " " +
                              this.guarantorDetails.lastName
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Phone Number</p>
                      <div class="input-box info-details">
                        {{
                          this.guarantorDetails && this.guarantorDetails.phone
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="dashboard__form-group info-details-spacing">
                    <div class="form-el">
                      <p>Address</p>
                      <div class="input-box info-details">
                        {{
                          this.guarantorDetails && this.guarantorDetails.address
                        }}
                      </div>
                    </div>

                    <div class="form-el">
                      <p>Name of company</p>
                      <div class="input-box info-details">
                        {{
                          this.guarantorDetails &&
                            this.guarantorDetails.companyName
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Guarantors information -->
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <loader :loader="loader"></loader>

    <AppModal
      :show="showRejectionModal"
      @onclosed="handleCosingRejectionModal"
      :styleGotten="{ 'max-width': '700px', top: '4%' }"
    >
      <h2 class="mb-5">Reject Loan</h2>

      <form action @submit.prevent="handleLoanRejection">
        <float-label class="form__input-wrap">
          <textarea
            type="text"
            v-model="rejectedReason"
            required
            class="text__input"
            placeholder="Enter rejection reason"
            rows="6"
          />
        </float-label>

        <button
          :class="{ disabled: !rejectedReason }"
          type="submit"
          :disabled="!rejectedReason || isRejectionLoading"
          class="createAcct__ctaBtn"
          @click="handleLoanRejection"
        >
          <svgicon
            v-if="isRejectionLoading"
            icon="spinner"
            class="button__loader"
          ></svgicon
          >Decline Loan
        </button>
      </form>
    </AppModal>

    <AppModal
      :show="showApprovedAmountModal"
      @onclosed="showApprovedAmountModal = false"
      :styleGotten="{ 'max-width': '700px', top: '4%' }"
    >
      <h2 class="mb-5">Approve Loan</h2>

      <form action @submit.prevent="handleLoanApproval">
        <float-label class="form__input-wrap">
          <input
            type="text"
            v-model="approvedAmount"
            required
            placeholder="Enter approved amount"
            class="form__input"
          />
        </float-label>

        <button
          :class="{ disabled: !approvedAmount }"
          type="submit"
          :disabled="!approvedAmount || loading"
          class="createAcct__ctaBtn"
          @click="handleLoanApproval"
        >
          <svgicon
            v-if="loading"
            icon="spinner"
            class="button__loader"
          ></svgicon
          >Approve
        </button>
      </form>
    </AppModal>

    <AppModal
      :show="showRepaymentPaidModal"
      @onclosed="showRepaymentPaidModal = false"
      :styleGotten="{ 'max-width': '500px', top: '15%' }"
    >
      <h2 class="mb-5">Mark repayment as paid</h2>

      <form action @submit.prevent="handleMarkLoanRepayments">
        <float-label class="form__input-wrap">
          <input
            type="date"
            v-model="repaymentDate"
            required
            class="form__input"
          />
        </float-label>

        <button
          :class="{ disabled: !repaymentDate }"
          type="submit"
          :disabled="!repaymentDate || markRepaymentLoader"
          class="createAcct__ctaBtn"
          @click="handleMarkLoanRepayments"
        >
          <svgicon
            v-if="markRepaymentLoader"
            icon="spinner"
            class="button__loader"
          ></svgicon
          >Mark as paid
        </button>
      </form>
    </AppModal>
    <AppModal
      :show="showInitiateRepaymentModal"
      @onclosed="showInitiateRepaymentModal = false"
      :styleGotten="{ 'max-width': '500px', top: '15%' }"
    >
      <h2 class="mb-5">Initiate loan repayment</h2>

      <form action @submit.prevent="handleLoanRepayment">
        <float-label class="form__input-wrap">
          <input
            type="number"
            v-model="repaymentAmount"
            required
            placeholder="Amount"
            class="form__input"
          />
        </float-label>
        <div class="place-btn">
          <button
            :class="{ disabled: !repaymentAmount }"
            type="submit"
            :disabled="!repaymentAmount || loading"
            class="mark-btn"
            @click="handleLoanRepayment"
          >
            <svgicon
              v-if="loading"
              icon="spinner"
              class="button__loader"
            ></svgicon
            >Initiate repayment
          </button>
        </div>
      </form>
    </AppModal>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import AppModal from "../resuables/modal";
import {
  getSingleLoan,
  approveLoan,
  rejectLoan,
  getPersonalDetails,
  getNextOfKinDetails,
  getEmploymentDetails,
  getBankDetails,
  getUploadedDocuments,
  getUserBankStatement,
  getGuarantorDetails,
  disburseLoan,
  initiateRepayment,
  markLoanAsPaid,
  markLoanRepayment
} from "../../../services/loans";

import { analyzeBankStatement } from "../../../services/rnplFinancials";
import { truncateText } from "../../utils/index";
import { formatReadbleDate } from "../../utils";
import StatusBadge from "../general/statusBadge.vue";

export default {
  name: "loan-details",
  components: {
    loader,
    AppModal,
    StatusBadge
  },
  data() {
    return {
      approvedAmount: "",
      rejectedReason: "",
      loanId: this.$route.params.id,
      loanDetails: {},
      repaymentList: [],
      userDetails: {},
      nextOfKinDetails: {},
      employmentDetails: {},
      uploadedDocuments: {},
      guarantorDetails: {},
      bankStatement: {},
      bankDetails: [],
      loader: false,
      loading: false,
      isRejectionLoading: false,
      analysingLoader: false,
      activeFinancialInfoTab: "income",
      showApprovedAmountModal: false,
      showRejectionModal: false,
      personalInformationOption: "basic_information",
      financialInformationOption: "financial_info",
      additionalInformationOption: "guarantor_information",
      showRepaymentPaidModal: false,
      showInitiateRepaymentModal: false,
      repaymentDate: "",
      repaymentAmount: "",
      repaymentLoader: false,
      markAsPaid: false,
      repaymentId: "",
      markRepaymentLoader: false,
      loanStatus: ""
    };
  },
  computed: {
    loanStatusCheck: function() {
      return this.loanStatus === "disbursed" || this.loanStatus === "overdue";
    }
  },
  methods: {
    handleDocumentDownload(key, isBankStatement) {
      if (isBankStatement) {
        window.open(this.bankStatement[key]);
      } else {
        window.open(this.uploadedDocuments[key]);
      }
    },

    handleCosingRejectionModal() {
      this.showRejectionModal = false;
      this.rejectedReason = "";
    },

    handleBankStatementAnalysis() {
      this.analysingLoader = true;

      const body = {
        loanId: this.loanId,
        statementProvider: "okra"
      };
      analyzeBankStatement(body)
        .then(res => {
          if (res.statusCode === 201) {
            this.$notification.success({
              message: "Bank Statement Sent",
              description: res.message || ""
            });
          }

          if (res.status === 404 || res.status === 500) {
            this.$notification.error({
              message: "Error",
              description: res.data.message || ""
            });
          }
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.analysingLoader = false;
        });
    },

    onTruncateText(text) {
      return truncateText(text, 40);
    },

    handleGetPersonalDetails(id) {
      getPersonalDetails(id).then(res => {
        this.userDetails = res.data;
      });
    },

    formatDate(date) {
      return formatReadbleDate(date);
    },

    handleGetGuarantorDetails(id) {
      getGuarantorDetails(id).then(res => {
        this.guarantorDetails = res.data;
      });
    },

    handleGetNextOfKinDetails(id) {
      getNextOfKinDetails(id).then(res => {
        this.nextOfKinDetails = res.data;
      });
    },

    handleGetUploadedDocuments(id) {
      getUploadedDocuments(id).then(res => {
        this.uploadedDocuments = res.data;
      });
    },

    handleGetEmploymentDetails(id) {
      getEmploymentDetails(id).then(res => {
        this.employmentDetails = res.data;
      });
    },

    handleGetBankDetails(id) {
      getBankDetails(id).then(res => {
        this.bankDetails = res.data;
      });
    },

    handleGetBankStatement(id) {
      getUserBankStatement(id).then(res => {
        this.bankStatement = res.data;
      });
    },

    handleGetSingleLoan() {
      this.loader = true;
      getSingleLoan(this.loanId)
        .then(res => {
          this.repaymentList = res.data.repayments;
          this.loanDetails = res.data;
          this.loanStatus = res.data.loan.status;

          Promise.all([
            this.handleGetPersonalDetails(res.data.loan.userId),
            this.handleGetNextOfKinDetails(res.data.loan.userId),
            this.handleGetEmploymentDetails(res.data.loan.userId),
            this.handleGetBankDetails(res.data.loan.userId),
            this.handleGetUploadedDocuments(res.data.loan.userId),
            this.handleGetBankStatement(res.data.loan.userId),
            this.handleGetGuarantorDetails(res.data.loan.userId)
          ]);
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loader = false;
        });
    },

    onDisbursementTrigger() {
      this.loader = true;
      disburseLoan(this.loanId)
        .then(res => {
          if (res.statusCode === 400 || res.statusCode !== 200) {
            if (typeof res.data.message != "string") {
              res.data.message.forEach(err => {
                this.$notification.error({
                  message: res.data.error,
                  description: err
                });
              });
            } else {
              this.$notification.error({
                message: res.data.error,
                description: res.data.message
              });
            }

            return;
          }
          this.handleGetSingleLoan();
          this.$notification.success({
            message: "Loan Disbursed!",
            description: res.message || "Loan Disbursed Successfully"
          });
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loader = false;
        });
    },

    handleLoanRejection() {
      this.isRejectionLoading = true;
      rejectLoan(this.loanId, { rejectionReasons: this.rejectedReason })
        .then(res => {
          if (res.statusCode === 400 || res.statusCode !== 200) {
            if (typeof res.data.message != "string") {
              res.data.message.forEach(err => {
                this.$notification.error({
                  message: res.data.error,
                  description: err
                });
              });
            } else {
              this.$notification.error({
                message: res.data.error,
                description: res.data.message
              });
            }

            return;
          }
          this.handleGetSingleLoan();
          this.$notification.success({
            message: "Loan Rejected!",
            description: res.message || "Loan Rejected Successfully"
          });
          this.handleCosingRejectionModal();
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.isRejectionLoading = false;
        });
    },

    onApprovalTrigger() {
      this.showApprovedAmountModal = true;
    },

    handleLoanApproval() {
      this.loading = true;
      const payload = {
        loanId:
          (this.loanDetails &&
            this.loanDetails.loan &&
            this.loanDetails.loan.id) ||
          "",
        approvedAmount: Number(this.approvedAmount) || 0
      };

      approveLoan(payload)
        .then(res => {
          if (res.statusCode === 400 || res.statusCode !== 201) {
            if (typeof res.data.message != "string") {
              res.data.message.forEach(err => {
                this.$notification.error({
                  message: res.data.error,
                  description: err
                });
              });
            } else {
              this.$notification.error({
                message: res.data.error,
                description: res.data.message
              });
            }

            return;
          }

          this.handleGetSingleLoan();
          this.$notification.success({
            message: "Loan Approved!",
            description: "You have successfully approved a loan"
          });
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loading = false;
          this.showApprovedAmountModal = false;
          this.approvedAmount = "";
        });
    },
    onRepaymentTrigger(repayment) {
      this.repaymentId = repayment.id;
      this.showRepaymentPaidModal = true;
    },
    handleRepaymentModal() {
      this.showInitiateRepaymentModal = true;
    },
    handleLoanRepayment() {
      this.loading = true;
      const payload = {
        loanId: this.loanDetails.loan.id,
        amount: Number(this.repaymentAmount)
      };
      initiateRepayment(payload)
        .then(res => {
          if (res.statusCode === 400 || res.statusCode !== 201) {
            if (typeof res.data.message != "string") {
              res.data.message.forEach(err => {
                this.$notification.error({
                  message: res.data.error,
                  description: err
                });
              });
            } else {
              this.$notification.error({
                message: res.data.error,
                description: res.data.message
              });
            }

            return;
          }

          this.handleGetSingleLoan();
          this.$notification.success({
            message: "Loan Repayment!",
            description: "You have successfully marked this repayment as paid"
          });
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loading = false;
          this.showInitiateRepaymentModal = false;
          this.repaymentAmount = "";
        });
    },
    handleMarkAsPaid() {
      this.markAsPaid = true;
      markLoanAsPaid(this.loanId)
        .then(res => {
          if (res.statusCode === 400 || res.statusCode !== 200) {
            if (typeof res.data.message != "string") {
              res.data.message.forEach(err => {
                this.$notification.error({
                  message: res.data.error,
                  description: err
                });
              });
            } else {
              this.$notification.error({
                message: res.data.error,
                description: res.data.message
              });
            }
            return;
          }

          this.handleGetSingleLoan();
          this.$notification.success({
            message: "Loan Marked As Paid!",
            description: "You have successfully marked this loan as paid"
          });
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.markAsPaid = false;
        });
    },
    handleMarkLoanRepayments() {
      this.markRepaymentLoader = true;
      markLoanRepayment(this.repaymentId, {
        datePaid: this.repaymentDate,
        status: "paid"
      })
        .then(res => {
          if (res.statusCode === 400 || res.statusCode !== 200) {
            if (typeof res.data.message != "string") {
              res.data.message.forEach(err => {
                this.$notification.error({
                  message: res.data.error,
                  description: err
                });
              });
            } else {
              this.$notification.error({
                message: res.data.error,
                description: res.data.message
              });
            }

            return;
          }
          this.handleGetSingleLoan();
          this.$notification.success({
            message: "Mark Loan As Paid!",
            description: res.message || "Mark Loan As Paid Successfully"
          });
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.markRepaymentLoader = false;
          this.showRepaymentPaidModal = false;
          this.repaymentId = "";
          this.repaymentDate = "";
        });
    }
  },
  async mounted() {
    this.handleGetSingleLoan();
  }
};
</script>

<style scoped lang="scss">
.loan-details-card {
  background-color: #ffffff;
  padding: 30px 40px;

  h4 {
    font-weight: 400;
    font-size: 14px;
  }
}
.financial-info-header-container {
  display: flex;
  margin: 0 0 0 auto;
  select {
    margin-bottom: 0;
    width: 250px;
    border-radius: 25px;
  }
}
.financial-info-tab {
  color: #abaebf;
  font-size: 13.5px;
  border-bottom: 1px solid #e9edfc;
  margin-bottom: 25px;

  .header-item {
    padding-bottom: 10px;
    cursor: pointer;
  }

  .active-header {
    border-bottom: 3px solid #2e48da;
    color: #2e48da;
  }
}
.document-upload-icon-container {
  display: flex;
  align-items: center;
  margin: 13px 50px 30px 0;
  .document-upload-icon {
    width: 25px;
  }

  p {
    color: #2d48da;
    font-size: 12.5px;
    margin: 0 0 0 10px;
    text-decoration: underline;
    cursor: pointer;
  }
}
.bank-card-container {
  background-image: linear-gradient(to right, #000000, #3f4252);
  height: 150px;
  width: 266px;
  border-radius: 12px;
  display: flex;
  padding: 18px;
  align-items: end;
  margin: 0 50px 30px 0;
  position: relative;

  .card-details-icon {
    fill: #62e2aa;
    position: absolute;
    width: 125px;
    top: 0;
    right: 0;
  }

  .fields {
    color: #ffffff;
    width: 100%;

    h3 {
      color: #ffffff;
      font-size: 14px;
    }

    .details-container {
      display: flex;
      justify-content: space-between;
    }
  }
}

.repayment-header {
  color: #2d48da;
  text-align: center;
  font-size: 19px;
  margin-bottom: 40px;
}

.initiate-btn {
  border-radius: 20px;
  border: 2px solid #2e48da;
  background: transparent;
  color: #2e48da;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 24px;
  height: 40px;
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.mark-btn {
  border-radius: 20px;
  border: 2px solid #2e48da;
  background: transparent;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 24px;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #2d48da;
}

.place-btn {
  display: flex;
  justify-content: center;
}

.initiate-btn:disabled {
  color: #b1bcfd;
  opacity: 1;
  border: 2px solid #b1bcfd;
}

.mark-btn:disabled {
  color: #9ba4d6;
  opacity: 1;
  background-color: #cfd6ff;
  border: 2px solid #cfd6ff;
}

.header-grp {
  margin-top: 10px;
}

.info-details {
  border: none !important;
  padding-inline: 0px !important;
  border-radius: 12px !important;
  width: 100% !important;
  background-color: transparent;
}

.info-details-spacing {
  display: grid !important;
  grid-template-columns: 2fr 2fr 1fr;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/loanDetails.vue